// TODO: ninesegsAnalyzer app からの依存をなくす
import { type TFunction } from 'i18next'
import * as R from 'remeda'

import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { type BrandAccount, type DocumentImage } from '~/gql/graphql'

import { exists } from '../../generals'
import {
  type FigureInfo,
  type FigureInfoKey,
  figureInfoKeys,
} from '../figureInfo'

import { getFigureInfoValue } from './internal/getFigureInfoValue'

const figureInfoKeyPathKeysMap: Partial<Record<FigureInfoKey, PathKey[]>> = {
  groupFilters: ['customizedAnalysis'],
  overlapGroupFilters: ['overlapAnalysis'],
  surveyFilter: [
    'customerAnalysis',
    'standardAnalysis',
    'customizedAnalysis',
    'overlapAnalysis',
    'whoAndWhatAnalysis',
  ],
  surveyGroupFilter: ['timeSeriesAnalysis'],
  tableChartType: ['timeSeriesAnalysis'],
  resultViewerType: ['customizedAnalysis', 'overlapAnalysis'],
}

/**
 * DocumentImage を FigureInfo に変換します。
 *
 * @param documentImage - 変換する DocumentImage。
 * @param brandAccountId - BrandAccount の ID。
 * @param t - Translation function。
 * @returns 変換された FigureInfo。
 *
 * TODO: [i18n改善] t関数を引数で受け取る設計を見直す
 * 翻訳キーを返し、呼び出し側でt()を適用する形に変更することで、保守性の改善を行う
 */
export function fromDocumentImage(
  documentImage: App.PickGraphQL<DocumentImage, 'allMetadata' | 'pathKey'>,
  brandAccountId: BrandAccount['id'],
  t: TFunction,
): FigureInfo {
  return R.pipe(
    figureInfoKeys,
    R.filter((figureInfoKey) => {
      const pathKey = documentImage.pathKey as PathKey
      const pathKeys = figureInfoKeyPathKeysMap[figureInfoKey]

      return !exists(pathKeys) || pathKeys.includes(pathKey)
    }),
    R.mapToObj((figureInfoKey) => [
      figureInfoKey,
      getFigureInfoValue(documentImage, figureInfoKey, t),
    ]),
    R.merge({ brandAccountId }),
  ) as FigureInfo
}
